export default {
      id: "warningTriangle-usage",
      viewBox: "0 0 33 30",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#warningTriangle",
      toString: function () {
        return this.url;
      }
    }